module.exports = __webpack_public_path__ + "static/media/Vidya.000cde79.png";